<template>
  <div
    class="activity-wrap" 
  >
  <el-carousel height="236px" :direction="directionType" :autoplay="false" class="el-item1" @change="carouselChange">
    <el-carousel-item name="first" label="集团型客户" class="el-item">
      <div class="first-word-big">
        集团型客户
      </div>
      <div class="first-word-small">
        寻求集团自上而下的数字化营销转型，通过业务流、数据流、资金流三流合一，提供全记录、可分析、能洞察的业务解决方案
      </div>
      <div class="carousel-item-icon" style="display: flex;">
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/group-customers-one.png" alt="">
          <div class="first-word">投放获客</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/group-customers-two.png" alt="">
          <div class="first-word">全民营销</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/group-customers-three.png" alt="">
          <div class="first-word">活动裂变</div>
        </div>
        <div class="first-type active">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/group-customers-four.png" alt="">
          <div class="first-word">客户画像</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/group-customers-five.png" alt="">
          <div style="width: 60px;" class="first-word">自动化营销</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/group-customers-six.png" alt="">
          <div class="first-word">到案跟进</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/group-customers-seven.png" alt="">
          <div class="first-word">快速结佣</div>
        </div>
        <div class="first-type active">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/group-customers-eight.png" alt="">
          <div class="first-word">数据分析</div>
        </div>
      </div>
    </el-carousel-item>
    <el-carousel-item name="second" label="区域型客户" class="el-item">
      <div class="first-word-big">
        区域型客户
      </div>
      <div class="first-word-small">
        告别各项目单兵作战，资源统一集中到城市中台，打造轻量级案场，通过规模化的客户获取、客户运营、客户转化实现资源最优分配，创造多元增长路径
      </div>
      <div class="carousel-item-icon" style="display: flex;">
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/regional-customers-one.png" alt="">
          <div class="first-word">线上投放</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/regional-customers-two.png" alt="">
          <div class="first-word">工具获客</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/regional-customers-three.png" alt="">
          <div class="first-word">自渠管理</div>
        </div>
        <div class="first-type active">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/regional-customers-four.png" alt="">
          <div class="first-word">全民营销</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/regional-customers-five.png" alt="">
          <div class="first-word">自动分配</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/regional-customers-six.png" alt="">
          <div class="first-word">意向判定</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/regional-customers-seven.png" alt="">
          <div class="first-word">企微运营</div>
        </div>
      </div>
    </el-carousel-item>
    <el-carousel-item name="three" label="项目型客户" class="el-item">
      <div class="first-word-big">
        项目型客户
      </div>
      <div class="first-word-small">
        通过定制一站式可视化场景营销解决方案，让售楼更加立体，帮助置业顾问更便捷拓客，缩短项目去化周期
      </div>
      <div class="carousel-item-icon" style="display: flex;">
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/project-customers-one.png" alt="">
          <div class="first-word">线上展厅</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/project-customers-two.png" alt="">
          <div class="first-word">微沙盘</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/project-customers-three.png" alt="">
          <div class="first-word">VR带看</div>
        </div>
        <div class="first-type active">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/project-customers-four.png" alt="">
          <div class="first-word">大屏显示</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/project-customers-five.png" alt="">
          <div class="first-word">移动案场</div>
        </div>
        <div class="first-type">
          <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/project-customers-six.png" alt="">
          <div class="first-word">工作台</div>
        </div>
      </div>
    </el-carousel-item>
  </el-carousel>
    <div class="carousel-footer">
      <div class="first-word-big-button" @click="information" data-agl-cvt="5">免费试用</div>
      <div class="first-word-big-button button-two" @click="goSolutione">查看详情</div>
    </div>
  </div>
</template>
<script>
import { swTrackerClickReport } from '@/tracker.js'
export default {
  name: 'round-solution',
  props: {
  },
  data () {
    return {
      index: 0,
      browserWigth: 0,
    }
  },
  computed: {
    directionType () {
      return this.browserWigth > 980 ? 'vertical' : 'horizontal'
    },
  },
  created(){
    window.addEventListener('resize', this.getBrowserWidth)
    this.getBrowserWidth()
  },
  destroyed(){
    window.removeEventListener('resize', this.getBrowserWidth)
  },
  methods: {
    carouselChange(e) {
      this.index = e
      let srcData = 'https://cdn.ideamake.cn/sw-pc/images/all-round-solution.png'
      if(e===0){
        srcData = 'https://cdn.ideamake.cn/sw-pc/images/all-round-solution.png'
      }else if(e===1){
        srcData = 'https://cdn.ideamake.cn/sw-pc/images/all-round-solution-two.png'
      }else if(e===2){
        srcData = 'https://cdn.ideamake.cn/sw-pc/images/all-round-solution-three.png'
      }
      this.$emit('carouselData',srcData);
    },
    goSolutione () {
      switch (this.index) {
        case 0:
          swTrackerClickReport('sw_pc_view_detail', '全方位解决方案-集团型客户', '思为科技首页')
          return this.$router.push({ path: '/solution/group' })
        case 1:
          swTrackerClickReport('sw_pc_view_detail', '全方位解决方案-区域型客户', '思为科技首页')
          return this.$router.push({ path: '/solution/city' })
        case 2:
          swTrackerClickReport('sw_pc_view_detail', '全方位解决方案-项目型客户', '思为科技首页')
          return this.$router.push({ path: '/solution/project' })
      }
    },
    information() {
      this.$store.commit('doStayConsultation')
      this.$router.push({ name: 'reservation',params:{type: 1,} })
      switch (this.index) {
        case 0:
          return swTrackerClickReport('sw_pc_free_trial', '全方位解决方案-集团型客户', '思为科技首页')
        case 1:
          return swTrackerClickReport('sw_pc_free_trial', '全方位解决方案-区域型客户', '思为科技首页')
        case 2:
          return swTrackerClickReport('sw_pc_free_trial', '全方位解决方案-项目型客户', '思为科技首页')
      }
    },
    // 获取浏览器宽度
    getBrowserWidth(){
      this.browserWigth = window.innerWidth
    }
  }
}
</script>
<style lang="scss" scoped>
.activity-wrap{
  position: relative;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  height: 424px;
  background: rgba(0,7,33,0.3);
  backdrop-filter: blur(10px);
  .first-word-big{
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    margin-bottom: 25px;
  }
  .first-word-small{
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 60px;
  }
  .first-type{
    text-align: center;
    margin-right: 50px;
    font-size: 12px;
    .first-img{
      width: 32px;
      height: 32px;
      margin-bottom: 8px;
    }
    .first-word{
      width: 50px;
    }
  }
  
  .first-word-big-button{
      width: 106px;
      height: 40px;
      background: #3777F6;
      border-radius: 2px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 40px;
      cursor: pointer;
      text-align: center;
      margin-top: 30px;
      margin-right: 20px;
      &:hover{
        background: #5F92F8;
      }
  }
  .button-two{
    background: rgba(0,7,33,0.3); 
    border: 1px solid #FFFFFF;
    &:hover{
      background:rgba(0,7,33,0.3); 
      color: #3777F6;
      border-color: #3777F6;
    }
    &:active{
      background:rgba(0,7,33,0.3); 
      color: #3777F6;
      border-color: #3777F6;
    }
  }
  ::v-deep  .el-carousel{
    height: 100%;
  .el-carousel__container{
      margin-left: 240px;
      margin-top: 64px;
      overflow: hidden;
      .el-carousel__item{
        width: 832px;
        margin-left: 64px;
      }
    }
  }
  ::v-deep .el-carousel__indicators{
    top: 0;
    padding: 20px 0 12px 12px;
    width: 236px;
    height: 100%;
    background: rgba(0,7,33,0.3);
    .el-carousel__indicator{
      padding: 0; 
    
      .el-carousel__button{
        width: 212px;
        height: 52px;
        background: inherit;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        opacity: 1;
        border-radius: 1px;
      }
    }
    .is-active{
      .el-carousel__button{
        background: #3777F6;
      }
    }
  }
  .carousel-footer{
    display: flex;
    position: absolute;
    bottom: 65px;
    left: 304px;
  }

}
// 移动端布局
@import "../min-home";
</style>
